import { ArrowRight } from "lucide-react";

const CATALOGS = [
  {
    id: 1,
    name: "Catálogo de Productos",
    description: "Explora nuestra completa colección de accesorios electrónicos de calidad. Desde audífonos hasta cámaras de vigilancia, todo lo que necesitas en un solo lugar.",
    image: "/images/catalogo-accesorios.jpeg",
    tag: "Disponible",
    tagColor: "bg-[#FFE4E8] text-[#E65B78]",
  },
];

export default function CatalogSection() {
  return (
    <section id="catalogos" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#E65B78] mb-3">
            Recursos
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#111111] mb-4">
            Catálogos
          </h2>
          <p className="text-base md:text-lg text-[#5C5C5C] max-w-xl mx-auto">
            Descarga nuestros catálogos y conoce todos los productos que tenemos para ofrecerte.
          </p>
        </div>

        {/* Catalogs Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CATALOGS.map((catalog) => (
            <div
              key={catalog.id}
              data-testid={`catalog-card-${catalog.id}`}
              className="bg-[#FAFAFA] rounded-3xl overflow-hidden shadow-sm border border-gray-100 card-hover group"
            >
              {/* Catalog Image */}
              <div className="relative overflow-hidden bg-[#FFF5F7] h-64">
                <img
                  src={catalog.image}
                  alt={catalog.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                />
                {/* Tag */}
                <span className={`absolute top-4 left-4 text-xs font-bold px-3 py-1.5 rounded-full ${catalog.tagColor}`}>
                  {catalog.tag}
                </span>
              </div>

              {/* Catalog Info */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#111111] mb-2">{catalog.name}</h3>
                <p className="text-[#5C5C5C] text-sm leading-relaxed mb-5">{catalog.description}</p>

                {/* CTA */}
                <a
                  href={catalog.image}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`catalog-download-${catalog.id}`}
                  className="inline-flex items-center gap-1.5 bg-[#E65B78] hover:bg-[#D44B66] text-white text-sm font-bold px-4 py-2 rounded-full transition-all duration-200"
                >
                  Ver catálogo
                  <ArrowRight size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-[#5C5C5C] text-sm mb-4">
            ¿Necesitas más información sobre nuestros productos?
          </p>
          <a
            href="https://wa.me/50589984547?text=Hola%20Printacce%2C%20me%20gustaría%20obtener%20más%20información%20sobre%20sus%20catálogos"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="catalogs-consult-btn"
            className="inline-flex items-center gap-2 bg-[#E65B78] hover:bg-[#D44B66] text-white font-bold px-7 py-3.5 rounded-full transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Consultar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
